<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
@if (isSearching) {
  <div class="kbm-search-loading">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<p-table #pt [value]="ruPropertiesStatuss" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="ruPropertiesStatusId" selectionMode="single"
  [(selection)]="ruPropertiesStatus" (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="5000"
  [rowsPerPageOptions]="[5000,1000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">RU Properties Status</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--get channel data-->
        @if (!shortTermRentalId) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="getCMPullPropertiesStatusRS()">Refresh Channels</button>
        }

        <app-import-export importEnabled="false" [dataRetrived]="ruPropertiesStatuss" (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true"></app-import-export>

      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>

      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field"></p-sortIcon>
        </th>
      }
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="channels" appendTo="body"
            (onChange)="pt.filter($event.value, 'ruChannelId', 'in')" styleClass="p-column-filter"
            placeholder="Channels" [filter]="true" filterBy="label" [showClear]="true" optionLabel="label" optionValue="ruChannelId">
            <ng-template let-option pTemplate="item">
              <span>{{option.label}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="propertyValues" appendTo="body"
            (onChange)="pt.filter($event.value, 'puId', 'in')" styleClass="p-column-filter"
            placeholder="Property" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
        </th>
        <th [ngStyle]="{'width': 'auto'}">
          <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="booleans" appendTo="body"
            (onChange)="pt.filter($event.value, 'clusterActive', 'in')" styleClass="p-column-filter"
            placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
            <ng-template let-option pTemplate="item">
              <span>{{option.name}}</span>
            </ng-template>
          </p-dropdown>
          <!-- <input pInputText [style]="{'width':'50px','min-width':'90%'}" type="text" (input)="pt.filter($event.target.value, 'clusterActive', 'in')"></th> -->
          <th>
            <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="booleans" appendTo="body"
              (onChange)="pt.filter($event.value, 'unitActive', 'in')" styleClass="p-column-filter"
              placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
              <ng-template let-option pTemplate="item">
                <span>{{option.name}}</span>
              </ng-template>
            </p-dropdown>
          </th>
          <th>
            <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="booleans" appendTo="body"
              (onChange)="pt.filter($event.value, 'rateActive', 'in')" styleClass="p-column-filter"
              placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
              <ng-template let-option pTemplate="item">
                <span>{{option.name}}</span>
              </ng-template>
            </p-dropdown>
          </th>
          <th>
            <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="contentStatuses" appendTo="body"
              (onChange)="pt.filter($event.value, 'contentStatus', 'in')" styleClass="p-column-filter"
              placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
              <ng-template let-option pTemplate="item">
                <span>{{option.name}}</span>
              </ng-template>
            </p-dropdown>
          </th>
          <th>
            <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="aRIStatuses" appendTo="body"
              (onChange)="pt.filter($event.value, 'aRIStatus', 'in')" styleClass="p-column-filter"
              placeholder="Filter" [filter]="true" filterBy="name" [showClear]="true" optionLabel="name" optionValue="value">
              <ng-template let-option pTemplate="item">
                <span>{{option.name}}</span>
              </ng-template>
            </p-dropdown>
          </th>
          <th [ngStyle]="{'width': 'auto'}"><input pInputText [style]="{'width':'50px','min-width':'90%'}" type="text" (input)="pt.filter($event.target.value, 'aRIStatus', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input pInputText [style]="{'width':'50px','min-width':'90%'}" type="text" (input)="pt.filter($event.target.value, 'rateMarkup', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input pInputText [style]="{'width':'50px','min-width':'90%'}" type="text" (input)="pt.filter($event.target.value, 'rateId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input pInputText [style]="{'width':'50px','min-width':'90%'}" type="text" (input)="pt.filter($event.target.value, 'unitId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input pInputText [style]="{'width':'50px','min-width':'90%'}" type="text" (input)="pt.filter($event.target.value, 'externalUnitId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"><input pInputText [style]="{'width':'50px','min-width':'90%'}" type="text" (input)="pt.filter($event.target.value, 'propertyId', 'in')"></th>
          <th [ngStyle]="{'width': 'auto'}"></th>
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="footer">
      @if (shortTermRental?.vrboDisplayId) {
        <tr>
          <td>
            <a href="https://www.vrbo.com/{{shortTermRental?.vrboDisplayId}}" target="_blank">
              <img width="80px" height="auto" src="assets/img/channel/vrbo.png">
            </a>
          </td>
          <td colspan="12">
            <a href="https://www.vrbo.com/{{shortTermRental?.vrboDisplayId}}" target="_blank">
              {{shortTermRental?.propertyCode}}
            </a>
          </td>
        </tr>
      }
    </ng-template>
    <ng-template pTemplate="body" let-ruPropertiesStatus>
      @if (properties.length > 0) {
        <tr [pSelectableRow]="ruPropertiesStatus">
          <td><a href="{{getRefSrcUrl(ruPropertiesStatus)}}" target="_blank"><img width="80px" height="auto" src='{{getRefSrcImage(ruPropertiesStatus.ruChannelId)}}'></a></td>
          <td><a href="/property-edit/{{ruPropertiesStatus.puId}}" target="_blank">{{getPropertyCode(ruPropertiesStatus.puId)}}</a></td>
          <td [style.background-color]="getResStatusColor(ruPropertiesStatus.clusterActive)">{{ruPropertiesStatus.clusterActive}}</td>
          <td [style.background-color]="getResStatusColor(ruPropertiesStatus.unitActive)">{{ruPropertiesStatus.unitActive}}</td>
          <td [style.background-color]="getResStatusColor(ruPropertiesStatus.rateActive)">{{ruPropertiesStatus.rateActive}}</td>
          <td [style.background-color]="getContentStatusColor(ruPropertiesStatus.contentStatus)">{{ruPropertiesStatus.contentStatus}}</td>
          <td [style.background-color]="getContentStatusColor(ruPropertiesStatus.aRIStatus)">{{ruPropertiesStatus.aRIStatus}}</td>
          <td>{{getPercentage(ruPropertiesStatus.rateMarkup)}}</td>
          <td>{{ruPropertiesStatus.rateId}}</td>
          <td>{{ruPropertiesStatus.unitId}}</td>
          <td>{{ruPropertiesStatus.externalUnitId}} </td>
          <td>{{ruPropertiesStatus.propertyId}}</td>
          <td><span style="float:none">
            <a>
              <i class="pi pi-pencil" aria-hidden="true"
              style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(ruPropertiesStatus)"></i>
            </a>
          </span>
        </td>
      </tr>
    }
  </ng-template>
</p-table>